import '@backstage/ui/css/styles.css';
import './theme.css';

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import React from 'react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { RiSunLine } from '@remixicon/react';
import { kpcTheme } from './kpc.theme';

export const appThemes = [
  {
    id: 'kpc-dark',
    title: 'KPC Dark',
    variant: 'dark' as const,
    icon: <RiSunLine />,
    Provider: ({ children }: { children: React.ReactNode }) => (
      <UnifiedThemeProvider theme={kpcTheme} children={children} />
    ),
  },
];

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: appThemes.map(theme =>
    ThemeBlueprint.make({
      name: theme.id,
      params: { theme },
    }),
  ),
});
